import RecommendedShowCard from "./components/RecommendedShowCard";
import SeriesSubPage from "./components/SeriesSubPage";

/** The View all page's grid, also what it shows while its own query runs. */
export const RecommendationsGridSkeleton = () => (
  <div className="grid grid-cols-3 gap-3 sm:grid-cols-5 sm:gap-4">
    {Array.from({ length: 5 }, (_, i) => (
      <RecommendedShowCard.Skeleton key={i} />
    ))}
  </div>
);

/** View all recommendations while the series loads: the page's own shape. */
const SeriesRecommendationsSkeleton = () => (
  <SeriesSubPage.Skeleton
    testId="series-recommendations-skeleton"
    titleWidth="w-56"
  >
    <RecommendationsGridSkeleton />
  </SeriesSubPage.Skeleton>
);

export default SeriesRecommendationsSkeleton;
